
// 瀑布流item链接跳转
$('.leftWrap').on("click", '.content-item', function(){
    var url = $(this).attr('data-detailUrl');
    if(url){
        window.open(common.getLocalUrl(url));
    }
});

// 个人中心item链接跳转
$('.mineListBox,.downListBox').on("click", 'li', function(){
    var url = $(this).attr('data-detailUrl');
    if(url){
        window.open(common.getLocalUrl(url));
    }
});

// 商城item链接跳转
$('.hotSell').on("click", '.hotItem', function(){
    var url = $(this).attr('data-detailUrl');
    if(url){
        window.open(common.getLocalUrl(url));
    }
});

$('.newProducts,.salesBox').on("click", 'li', function(){
    var url = $(this).attr('data-detailUrl');
    if(url){
        window.open(common.getLocalUrl(url));
    }
});

// 产品中心/相关文章item链接跳转
$('.productItem,.articlesItem').on("click", 'li', function(){
    var url = $(this).attr('data-productUrl') || $(this).attr('data-articlesUrl');
    if(!url){
        return;
    }
    var position = $(this).attr('data-position');
    if (position) {
        url = url + '?recommendPosition=' + position;
        gioTrackAction.recommendContentClick(position);
    }
    window.open(common.getLocalUrl(url));
});

//跳转会场阻止冒泡
function doAttend(){
    stopEvent('click');
}

//相关文章标签阻止冒泡
$('.toTag, .btn-buy-interested, .stop-propagation').on("click", function(){
    stopEvent('click');
});

$('.stopPropagation').on("click", function(){
    stopEvent('click');
});
//阻止标签点击冒泡
function stopRurnLik(){
    $(".blockTag").on('click', function() {
        stopEvent('click');
    });
}

//作者阻止冒泡
$('.leftWrap,.productItem').on("click", '.blockFrom', function(){
    stopEvent('click');
});



//评论阻止冒泡
// $('.leftWrap,.productItem').on("click", '.comment', function(){
//     stopEvent('click');
// });

//联系戴尔
$('.productItem,.leftWrap,.mineListBox').on("click", '.toSales', function(){
    stopEvent('click');
    var productId = $(this).parents('.content-item,li').attr('data-product-id'),
        productName = $(this).parents('.content-item,li').attr('data-product-name'),
        productPrice = $(this).parents('.content-item,li').attr('data-product-price'),
        entrance = productName+'/'+productId;
    gio('track', 'ibuyClick')  //埋点实施方案
    if(productId){
        common.productOpenKefu(productId);
    }else{
        kefuServer.shouqian();
    }
});

//点赞事件 参数：id=>文章id, status=>当前文章的点赞状态
$('.leftWrap,.productItem,.dialog-video-box,.dialog-filepre-box,.mineListBox,.g-detail-container,.m-solution-list,.video-operate').on("click", '.like', function(){
    stopEvent('click');
    var thisDom = $(this),
        id = thisDom.attr('data-id'),
        status = thisDom.attr('data-status'),
        title = thisDom.attr('data-title');

    var usrInfo = isLogin();
    var likeText = '点赞并收藏成功';
    var unLikeText = '点赞/收藏已取消';
    //判断是否登录
    if (!usrInfo) {
        likeText = '点赞成功';
        unLikeText = '已取消点赞';
    }

    //如果点赞状态为true 则取消点赞
    if(status === 'true'){
        //点赞-1
        postJson(window.cateData.api.like, {articleId:id, status:0, sess:usrInfo.session},function(data){
            if(data.result > 0){
                console.log(data.desc);
                return;
            }else{
                //记录我喜爱的内容点赞
                if(window.cateData.pageSubModule == 'favorite'){
                    $.cookie('cancelCollect',true);
                }

                $('.act-like-'+ id).find('.likeNum').text(data.total);
                $('.act-like-'+ id).find( '.like-icon').removeClass('status-like-true');
                $('.act-like-'+ id).find( '.like-icon').addClass('status-like-false');
                $('.act-like-'+ id).attr('data-status', 'false');
                //行为记录
                userAction.removeFavorites(title);
                msg.toast(unLikeText);
                if(window.cateData.pageModule == 'detail'){
                    $(".sidebarWraArticle .zan").find("span").removeClass("coll");
                    $(".sidebarWraArticle .zan").attr("data-status",0);
                }
                if (window.cateData.pageModule == 'shopDetail') {
                    $('.j-collect-count').text(data.total);
                    thisDom.attr('data-status', 'false');
                    thisDom.find('.icon-appreciate-1').removeClass('u-orange');
                }
            }
        }, true);
    }else{
        //点赞+1
        gioTrackAction.collect();
        postJson(window.cateData.api.like, {articleId:id, status:1, sess:usrInfo.session},function(data){
            if(data.result > 0){
                console.log(data.desc);
                return;
            }else{
                $('.act-like-'+ id).find('.likeNum').text(data.total);
                $('.act-like-'+ id).find( '.like-icon').addClass('status-like-true');
                $('.act-like-'+ id).find( '.like-icon').removeClass('status-like-false');
                $('.act-like-'+ id).attr('data-status', 'true');
                //行为记录
                userAction.addFavorites(title);
                msg.toast(likeText);
                if(window.cateData.pageModule == 'detail'){
                    $(".sidebarWraArticle .zan").find("span").addClass("coll");
                    $(".sidebarWraArticle .zan").attr("data-status",1);
                }
                if (window.cateData.pageModule == 'shopDetail') {
                    $('.j-collect-count').text(data.total);
                    thisDom.attr('data-status', 'true');
                    thisDom.find('.icon-appreciate-1').addClass('u-orange');
                }
                gioTrackAction.collectSuccess();
            }
        }, true);
    }
});

//sess 不对需要登出
function loginOut() {
    delCookie('smarketMember_' + window.cateData.schemaId);
    delCookie('OCSESSID');
    gio('clearUserId');
    // window.location.href = window.cateData.url.loginAndBack;
    common.gotoLogin();
}

//处理时间
function handleTime() {
    $('.handle-time-box').each(function(){
        //获取页面的时间戳
        var timestamp = parseInt($(this).attr('date-timestamp'));
        if(!timestamp){
            return;
        }
        //处理时间
        var nowTime = parseInt(new Date().getTime() / 1000);
        var t = nowTime - timestamp;
        var res = '';

        //报名中t<0会是负数直接取接口时间
        if(t > 0){
            if(t < 3600){
                res = parseInt(t/60 )+ "分钟前";
            }else if (t>=3600 && t < 86400){
                res = parseInt(t/3600 )+ "小时前";
            }else if (t>=86400 && t < 864000){
                res = parseInt(t/86400 )+ "天前";
            }else{
                res = transformPHPTime(timestamp);
            }
            //设置时间
            $(this).text(res);
        }
    });

    //时间戳转日期
    function transformPHPTime(time){
        var date = new Date(time * 1000);

        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';

        return Y+M+D;
    }

}

//异步请求收藏数量，收藏状态，和评论数
function gettatInfo() {
    var handelArrEle = document.querySelectorAll('.handle-like-box');
    var articleIdArr = [];//要处理的文章id
    var elemArr = [];//需要处理的dom
    if(handelArrEle.length === 0){
        return;
    }

    $('.handle-like-box').each(function(){
        var articleId = $(this).attr('data-articleid');
        articleIdArr.push(articleId);
        elemArr[articleId] = $(this);
    });

    var articleIdStr = articleIdArr.join(',');

    var option = {
        'uid': window.cateData.userInfo.memberId,
        'articleId':articleIdStr
    };
    var postUrl = window.cateData.api.getCollectionStatus;
    postJson(postUrl, option, function (data) {
        if(data.result > 0){
            return;
        }

        $.each(data.content,function(index,value){
            $('.handle-like-box').each(function(){
                var articleId = $(this).attr('data-articleid');
                if(articleId === value.id) {
                    var likeStateWra = $(this).find('.like');  //点赞状态data-status
                    var likeStateEle = $(this).find('.like-icon');  //点赞状态点亮样式
                    var likeNumEle = $(this).find('.likeNum');  //点赞数
                    var commentNumEle = $(this).find('.commentNum');  //评论数
                    var browseNumEle = $(this).find('.browseNum');  //浏览量
                    if (likeStateEle) {
                        // console.log(value.id);
                        if (value.collect) {
                            // console.log(value.id+'点赞');
                            $(likeStateEle).removeClass('status-like-false');
                            $(likeStateEle).addClass('status-like-true');
                            $(likeStateWra).attr('data-status', true);
                        } else {
                            $(likeStateEle).removeClass('status-like-true');
                            $(likeStateEle).addClass('status-like-false');
                            $(likeStateWra).attr('data-status', false);
                        }
                    }
                    if (likeNumEle) {
                        likeNumEle.text(value.collectCount);
                    }
                    if (commentNumEle) {
                        commentNumEle.text(value.commentCount);
                    }
                    if (browseNumEle) {
                        browseNumEle.text(value.browseCount);
                    }
                }
            });
        });
    }, true);
}

//意向单埋码方法
function fireTag(){
    return
    // var evp = document.createElement('img');
    // evp.height = 1;
    // evp.width = 1;
    // evp.style.display = "none";
    // evp.src = "http://adfarm.mediaplex.com/ad/bk/10592-61498-3840-0?Enquiry_PopupClick_emc_sol=1&HVE_emc_sol=1&HVE=1&mpuid=" + document.location;
    // document.body.appendChild(evp);
}

//单篇文章获取点赞状态
function getCollectionStatus(articleId, collectionEl) {

    collectionEl.className = 'like';

    collectionEl.classList.add('act-like-' + articleId);
    //设置id类
    var collectionIconEl = collectionEl.querySelector('.like-icon');

    var postUrl = window.cateData.api.getCollectionStatus;
    var option = {
        'uid': window.cateData.userInfo.memberId,
        'articleId': articleId
    };
    postJson(postUrl, option, function (data) {
        if (data.result > 0) {
            return;
        }
        if (data.content[0].collect) {
            collectionIconEl.classList.remove('status-like-false');
            collectionIconEl.classList.add('status-like-true');
            //设置状态
            collectionEl.setAttribute('data-status', 'true');
        } else {
            collectionIconEl.classList.remove('status-like-true');
            collectionIconEl.classList.add('status-like-false');
            //设置状态
            collectionEl.setAttribute('data-status', 'false');
        }
        return data.content;
    }, true);
}

//关注 取消关注
var subscribe = function (authorId, authorName, status) {

    var bt = document.querySelector('.focusbt');
    var unbt = document.querySelector('.un-focusbt');
    //dom操作
    function setSubscribeBt() {
        unbt.classList.remove('hide');
        bt.classList.add('hide');
    }

    function setUnsubscribeBt() {
        bt.classList.remove('hide');
        unbt.classList.add('hide');
    }

    function loginStatus() {
        var usrInfo = isLogin();
        if (!usrInfo) {
            //行为记录
            if (status) {
                userAction.focusAuthor('无');
            } else {
                userAction.cancelFocusAuthor('无');
            }
            common.gotoLogin();
            return;
        }
    }

    var subscribeObj = {};
    var url = '';
    subscribeObj.do = function () {
        loginStatus();
        if(status){
            url = '/api/interaction/author/' + authorId + '/collect/' + 1;
            getJson(url, '',  function (data) {
                if(data.result == 0){
                    userAction.focusAuthor(authorName);
                    setSubscribeBt();
                }else{
                    msg.toast(data.desc);
                }
            }, true);
        }else{
            url = '/api/interaction/author/' + authorId + '/collect/' + 0;
            getJson(url, '',  function (data) {
                if(data.result == 0){
                    userAction.cancelFocusAuthor(authorName);
                    setUnsubscribeBt();
                }else{
                    msg.toast(data.desc);
                }
            }, true);
        }
    };
    return subscribeObj;
};

/**
 *
 * @param inputCls
 * @param increaseCls
 * @param decreaseCls
 * @returns {{getInputVal: *, setInputVal: *, destroy: *}}
 */
function numInput(inputCls, increaseCls, decreaseCls, numLimit) {
    var _this = this;
    _this.inputDom = null;
    _this.increaseDom = null;
    _this.decreaseDom = null;

    _this.inputDom = document.querySelector(inputCls);
    _this.increaseDom = document.querySelector(increaseCls);
    _this.decreaseDom = document.querySelector(decreaseCls);

    if(!_this.inputDom || !_this.increaseDom || !_this.decreaseDom){
        return;
    }

    _this.inputVal = _this.inputDom.value;

    _this.increaseNum = function () {
        if(numLimit || numLimit == 0){
            if(_this.inputVal >= numLimit){
                return;
            }
        }
        _this.inputVal++;
        _this.inputDom.value = _this.inputVal;
    };

    _this.decreaseNum = function () {
        if(numLimit == 0){
            return;
        }
        if (_this.inputVal <= 1) {
            _this.inputVal = 1;
        } else {
            _this.inputVal--;
        }
        _this.inputDom.value = _this.inputVal;
    };

    _this.changeNum = function() {
        var curVal = _this.inputVal;
        if (!(/^(\d+)$/g.test(_this.inputDom.value))) {
            _this.inputDom.value = !_this.inputDom.value ? 0 : parseInt(curVal);
        }
        if(numLimit || numLimit == 0){
            if(parseInt(_this.inputDom.value) >= parseInt(numLimit)){
                _this.inputDom.value = numLimit;
            }
        }
        _this.inputVal = _this.inputDom.value;
    };

    _this.increaseDom.addEventListener('click', _this.increaseNum);
    _this.decreaseDom.addEventListener('click', _this.decreaseNum);
    _this.inputDom.addEventListener('keyup', _this.changeNum);

    _this.getInputVal = function () {
        return _this.inputVal;
    };

    _this.setInputVal = function (val) {
        _this.inputVal = val;
    };

    _this.destroy = function() {
        _this.increaseDom.removeEventListener('click', _this.increaseNum);
        _this.decreaseDom.removeEventListener('click', _this.decreaseNum);
        numLimit = null
    };

    return {
        setInputVal: this.setInputVal,
        getInputVal: this.getInputVal,
        destroy: this.destroy
    };
}


//我有意向购买按钮弹窗
function planBuyAct(productInfo){
    stopEvent('click');
    fireTag();
    var opts = {
        productid:'',
        productname:'',
        productprice:'',
        salePrice:'',
        productImg:'',
        productDesc:'',
        entrance:'',
        productnum:1
    };
    $.extend(opts, productInfo);
    console.log(opts);

    opts.entrance = opts.productName+'/'+opts.productId;
    opts.unSalePrice = opts.productprice;
    opts.productprice = opts.salePrice || opts.productprice || '';


    //打开弹窗
    msg.bargainDialog(opts, window.cateData.purchaseIntentionForm);

    //埋点实施方案
    gio('track', 'ibuyClick')

}


